/** @format */

(function() {
	'use strict';

	angular.module('emsApp').constant('paginationConstants', {
		itemsPerPage: 20,
	});
})();
